<template>
  <form
    id="signup"
    @submit="checkForm"
    action="#"
    method="post"
    novalidate="true"
    v-if="!mfa"
  >
    <h1>{{ $t("onboard.signUpForm.header") }}</h1>

    <label class="required" for="email">{{
      $t("onboard.signUpForm.email")
    }}</label>
    <input
      id="email"
      readonly="readonly"
      v-bind:class="{ error: errEmail }"
      name="email"
      v-model="email"
    />

    <label class="required" for="name-first">{{
      $t("onboard.signUpForm.firstName")
    }}</label>
    <input
      id="name-first"
      v-bind:class="{ error: errNameFirst }"
      name="name-first"
      v-model="nameFirst"
      v-on:input="errNameFirst = false"
    />
    <p class="error" v-if="errNameFirst">
      {{ $t("onboard.signUpForm.noFirstName") }}
    </p>

    <label class="required" for="name-last">{{
      $t("onboard.signUpForm.lastName")
    }}</label>
    <input
      id="name-last"
      v-bind:class="{ error: errNameLast }"
      name="name-last"
      v-model="nameLast"
      v-on:input="errNameLast = false"
    />
    <p class="error" v-if="errNameLast">
      {{ $t("onboard.signUpForm.noLastName") }}
    </p>

    <label class="required" for="pass">{{
      $t("onboard.signUpForm.password")
    }}</label>
    <span v-if="errPasswordStrength" class="error">
      {{ $t("onboard.signUpForm.errorMsg") }}
    </span>
    <input
      type="password"
      v-bind:class="{ error: errPassword }"
      name="password"
      id="pass"
      v-model="password"
      v-on:input="
        errPassword = false;
        errPasswordStrength = false;
      "
    />
    <p class="error" v-if="errPassword">
      {{ $t("onboard.signUpForm.noPassword") }}
    </p>

    <input
      type="submit"
      class="submit"
      v-bind:value="$t('onboard.signUpForm.button.signup')"
    />

    <SelectLang />
  </form>
  <MFAInput v-else />
</template>

<script>
import SelectLang from "@/components/onboard/SelectLanguage.vue";
import { userService } from "@/services/user.service";
import { validEmail } from "@/utils/validEmail";
import { validFileInclusion } from "@/utils/validFileInclusion";
import MFAInput from "@/components/onboard/MFAInput.vue";

export default {
  name: "SignUpFrom",
  props: ["foundEmail"],
  components: { MFAInput, SelectLang },
  data() {
    return {
      invalidForm: true,
      errEmail: false,
      errNameFirst: false,
      errNameLast: false,
      errPassword: false,
      errPasswordStrength: false,
      email: null,
      nameFirst: null,
      nameLast: null,
      password: null,
      mfa: false,
    };
  },
  created: function() {
    if (localStorage.getItem("mfaExpired")) {
      const mfaExpired = localStorage.getItem("mfaExpired");
      const now = Date.now();
      if (now < parseInt(mfaExpired, 10)) {
        this.setMfa(true);
      } else {
        localStorage.removeItem("mfaExpired", true);
      }
    }
    if (this.foundEmail) {
      this.email = this.foundEmail;
    }
  },
  methods: {
    checkForm: function(event) {
      this.invalidForm = false;
      this.errEmail = false;
      this.errNameFirst = false;
      this.errNameLast = false;
      this.errPassword = false;
      this.errPasswordStrength = false;

      // If-stravaganza
      if (!this.email || !validEmail(this.email)) {
        this.invalidForm = true;
        this.errEmail = true;
      }
      if (!this.nameFirst || validFileInclusion(this.nameFirst)) {
        this.invalidForm = true;
        this.errNameFirst = true;
      }
      if (!this.nameLast || validFileInclusion(this.nameLast)) {
        this.invalidForm = true;
        this.errNameLast = true;
      }
      if (!this.password || validFileInclusion(this.password)) {
        this.invalidForm = true;
        this.errPassword = true;
      }

      if (!this.invalidForm) {
        this.signup();
      }
      event.preventDefault();
    },

    signup: function() {
      let pendingUser = {
        currentPassword: "",
        emailAddress: this.email,
        enabled: true,
        familyName: this.nameLast,
        givenName: this.nameFirst,
        newPassword: this.password,
      };

      // Invites are special.
      if (
        localStorage.getItem("groupInvite") ||
        localStorage.getItem("planInvite")
      ) {
        if (localStorage.getItem("groupInvite")) {
          pendingUser.inviteType = "group";
          pendingUser.inviteToken = localStorage.getItem("groupInvite");
        } else {
          pendingUser.inviteType = "plan";
          pendingUser.inviteToken = localStorage.getItem("planInvite");
        }

        // Skip validation/create user/and go straight to profile creation.
        userService
          .registerAndAccept(pendingUser)
          .then((resp) => {
            if (resp.user.mfa === true) {
              this.setMfa(true);
              localStorage.setItem("inviteType", pendingUser.inviteType);
              localStorage.setItem("pathId", resp[pendingUser.inviteType].id);
            } else {
              if (resp.user.token) {
                // Remove the token from the session.
                localStorage.removeItem(pendingUser.inviteType + "Invite");

                // Move on to profile creation, and pass along a destination.
                this.$router.push(
                  "/profile-create?dest=/" +
                    pendingUser.inviteType +
                    "/" +
                    resp[pendingUser.inviteType].id
                );
              }
            }
          })
          .catch((err) => {
            if (err === "badPw") {
              this.invalidForm = true;
              this.errPasswordStrength = true;
            } else {
              console.error("Something went wrong accepting token: ", err);
            }
          });
      } else {
        userService.signup(pendingUser).then((res) => {
          if (res.userId) {
            this.$router.push("verify");
          }
        });
      }
    },
    setMfa: function(mfa) {
      this.mfa = mfa;
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  margin: -17px 0px 25px !important;
}
</style>
